module.exports = __webpack_public_path__ + "static/media/radiopharma.b5e0392f.svg";